export type RuntimeDiagnosticMode =
  | 'bare'
  | 'welcome'
  | 'workspace-shell'
  | 'empty-flow'
  | 'flow-no-assistant'
  | 'flow-no-edges'
  | 'flow-text-only'
  | 'flow-image-only'
  | 'flow-image-generator-only'

const supportedModes = new Set<RuntimeDiagnosticMode>([
  'bare',
  'welcome',
  'workspace-shell',
  'empty-flow',
  'flow-no-assistant',
  'flow-no-edges',
  'flow-text-only',
  'flow-image-only',
  'flow-image-generator-only',
])

export function isReadOnlyFlowDiagnostic(mode?: RuntimeDiagnosticMode) {
  return mode === 'empty-flow' || mode?.startsWith('flow-') === true
}

export function readRuntimeDiagnosticMode(
  search = typeof window === 'undefined' ? '' : window.location.search,
  configuredMode = import.meta.env.VITE_DIAGNOSTIC_MODE,
) {
  const value = new URLSearchParams(search).get('diagnostic') ?? configuredMode
  return supportedModes.has(value as RuntimeDiagnosticMode) ? value as RuntimeDiagnosticMode : undefined
}
